<template>
    <section class="">
        <h2 class="rich_media_title zhemo" id="activity-name">
            量化多因子？谁来帮忙做个名词解释
        </h2>
        <p><span></span></p>
        
        <p><span>然而一部分爱粉会弱弱的提问，什么叫量化多因子呀？小爱知道，不了解一种投资产品的情况下，投资者往往会担心风险而拒绝介入，然而这样很可能会与一些投资机遇失之交臂。小爱今天就把这些投资策略介绍给大家，让你从此不再迷茫。</span>
        </p>
        <p><span><br></span></p>
        <p><span>小爱的有一位股友和小爱说，每次他一买哪只股票哪只股票就开始跌，等到他一卖又开始涨，就像有人盯着自己的账户一样。这是因为股民的交易受情绪影响，而情绪是具有一定惯性的，当一个交易者看到股价上涨之后开始兴奋但是存在犹疑，当股价连续上涨之后终于情绪上的兴奋度足够让他冲进某只股票，然而在股民冲进去后前期进入这只股票的投资者已经有一定的获利积累，开始逐步减仓。</span>
        </p>
        <p><span><br></span></p>
        <p><span>当股市下跌时股民开始犹豫，幻想短期调整后行情继续，随着股价下跌持股者的信心受到打击，当持股者终于忍受不了心理上的折磨割掉手中的股票时抄底资金入场了，于是刚刚割肉出局的股民眼睁睁看着自己的筹码被别人接走反弹了。</span><br>
        </p>
        <p><span><br></span></p>
        <p><span>有没有一种办法能够避免情绪带来的不利因素呢，量化是个好办法。量化交易以数学模型替代人为的主观判断，利用计算机技术从庞大的历史数据中海选能带来超额收益的多种“大概率”事件以制定策略，减少了投资者情绪波动的影响，避免在市场极度狂热或悲观的情况下作出非理性的投资决策。</span>
        </p>
        <p><span><br></span></p>
        <p><span>量化投资的优势在于他有一定的纪律性和系统性，利用套利思想依据概率取胜。</span></p>
        <p><span></span></p>
        <p><span>量化多因子模型的基本逻辑又是怎样的呢？模型的逻辑在于因子动量的可持续性，即股票的当期因子和下期收益率之间存在序列相关性，该相关性显著且持续稳定。通过一系列数量化的方法挑选出这些因子，并赋予相应权重，计算股票在这些因子上的综合得分，精选得分高的股票构建投资组合。</span>
        </p>
        <p class=""><br></p>
        <p><span>多因子模型又是如何组建的呢？每月初和月中通过检验每个因子在考察期内有效性，选出有效因子；控制有效因子的个数在一定范围内，每月的因子数量和因子种类动态调整；对因子打分，依据数量方法赋予因子权重；依据股票的不同因子得分对该股票进行综合打分，选取得分较高的股票，在等权基础上构建投资组合。</span>
        </p>
        <p><span><br></span></p>
        <p><span></span></p>
        <!-- <section label="小黄人科技" donone="shifuMouseDownCard('shifu_c_018')">
            <span>这样的策略能够使得选股所基于的因素随市场而动，保证了交易的灵活性以及对市场的敏感性，同时避免了交易者的情绪因素，而且海富通的量化模型因素非常全面，充分考虑价值、成长、流动性、动量等十一个因子。</span>
        </section>
        <p class=""><br></p>
        <p><span>小爱注意到，海富通量化多因子灵活配置混合型基金还优化了数据模型来动态捕捉市场特征，并结合量化择时模型进行仓位调整，力争控制回撤并获取超越比较基准的投资回报。基金投资于股票资产占基金资产的比例为0%-95%，给予股票投资最大灵活度。</span>
        </p>
        <p><span><br></span></p>
        <p><img style="width:692px;height:154px;margin:0 auto;display:block;" class=""
                src="./img/img_2_7_1.png"
                alt="图片"></p>
        <p><span>&nbsp;</span></p>
        <p><span>9年证券从业经验，负责量化策略研究及量化对冲组合投资。专长于量化策略程序开发、量化产品设计以及衍生品投资。先后负责多个定向增发、量化对冲策略产品，具有丰富的投资管理经验。</span></p>
        <p><span><br></span></p>
        <p><span>目前管理的量化产品有海富通阿尔法对冲混合型基金、海富通东财大数据混合型基金、海富通量化前锋股票型基金等。</span></p>
        <p><span><br></span></p>
        <p><span></span></p>
        <p><span>根据海通证券排名，目前管理的海富通阿尔法对冲混合型基金2017年业绩位列对冲策略混合型分类20只基金中的第1名。</span></p>
        <p class=""><br></p>
        <p><span></span></p>
        <p><span>风险提示：我国基金运作时间较短，不能反映股市发展的所有阶段。基金的过往业绩并不预示其未来表现，基金管理人管理的其他基金的业绩并不构成基金业绩表现的保证。基金管理人承诺以诚实信用、勤勉尽责的原则管理和运用基金资产，但不保证基金一定盈利，也不保证最低收益。海富通基金郑重提醒您注意投资风险，请仔细阅读基金合同和基金招募说明书，了解基金的具体情况。</span>
        </p>
        <p><br></p>-->
        <p class="free">（来源：爱理财）</p> 
    </section>
</template>

<script>
    export default {

    }
</script>

<style scoped>

.zhemo{
    text-align: center;
    padding: 40px 0 20px 0;
    font-weight: bold;
     color: #6f6f6f!important;
}
.title2{
    font-weight: bold;
    line-height: 30px;
}
p,span{
    text-indent: 2em;
    font-size: 14px!important;
    color: #6f6f6f!important;
    letter-spacing: 0!important;
}
</style>